import { IMActivity } from '../../../types'
import { IM360Parser } from '../../IM360Parser'
import { parseHtmlString } from 'ingestion/nodeCreationHelpers'

function isEstimationExploration({ title }: IMActivity) {
  return (
    title.includes('Estimation Exploration') &&
    !title.trim().startsWith('Facilitate Your')
  )
}

export function parseEstimationExploration(
  {
    statement,
    studentResponse,
    title,
  }: { statement?: string; studentResponse?: string; title?: string },
  activity?: IMActivity,
) {
  if (!activity || !statement?.trim() || !isEstimationExploration(activity))
    return
  const asHtml = parseHtmlString(statement)
  const table = asHtml.getElementsByTagName('table').item(0)!
  table.remove()
  const answers: string[] = []
  const parser = IM360Parser.getInstance()
  Array.from(
    Array.from(table.getElementsByTagName('tbody'))
      .pop()!
      .getElementsByTagName('td'),
  ).forEach((td) => {
    td.innerText = parser.placeholderMarker
    answers.push('')
  })

  return [
    parser.buildPlaceholder({
      title,
      stimulus: asHtml.body.innerHTML,
      teacherNote: studentResponse,
      template: table.outerHTML,
      answers,
    }),
  ]
}
